
import axios from "axios"
import API_BASE_URI from "./api.config"
import { guardAuthRequests } from "../common/utils/authRequestGuard"

const axiosInstance = axios.create({
   baseURL: API_BASE_URI,
   headers: {
      "Content-Type": "application/json"
   }
})

// Block any `x-auth-token` (RTK Query) request when signed out — same central
// guarantee applied to the shared instances in common/utils/AxiosInstance.js.
guardAuthRequests(axiosInstance)

axiosInstance.interceptors.request.use(
   (config) => {
      const token = localStorage.getItem("token");
      if (token) {
         config.headers["x-access-token"] = token
      }
      return config
   },
   (error) => {
      return Promise.reject(error)
   }
)

axiosInstance.interceptors.response.use(
   (response) => response,
   (error) => Promise.reject(error)
);

export default axiosInstance;